import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { switchMap, tap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { NewsUpdateService } from './news-update.service';

@Component({
  selector: 'app-news-update',
  templateUrl: './news-update.component.html',
  styleUrls: ['./news-update.component.scss']
})
export class NewsUpdateComponent implements OnInit {
  allNews: any;
  page: number = 1;
  pageSize: number = 10;
  collectionSize: number;
  rows: any[];
  search: string;
  isSearch: boolean = false;
  searchNews: any = '';
  locationUrl: string = window.location.origin;
  alwaysOpen: boolean = true;

  column = [{
    field: 'NEWS_ID',
    header: 'รหัสข่าว',
    style: 'col'
  }, {
    field: 'NEWS_TITAL',
    header: 'ชื่อข่าว',
    style: 'col'
  }, {
    field: 'NEWS_CATEGORY',
    header: 'ประเภทข่าว',
    style: 'col'
  }, {
    field: 'NEWS_START',
    header: 'วัน เวลา ที่เปิด',
    style: 'col'
  }, {
    field: 'NEWS_END',
    header: 'วัน เวลา ที่ปิด',
    style: 'col'
  }, {
    field: 'NEWS_STATUS',
    header: 'สถานะ',
    style: 'col'
  }, {
    field: 'CREATENAME',
    header: 'ผู้เขียน',
    style: 'col'
  }, {
    field: 'EDIT',
    header: 'แก้ไข',
    style: 'col-1'
  }, {
    field: 'DUPLICATE',
    header: 'Duplicate',
    style: 'col-1'
  }]

  constructor(
    public matDialog: MatDialog,
    private newsService: NewsUpdateService,
    private gobalFunctionService: GobalFunctionService
  ) {
  }

  ngOnInit(): void {
    this.getAllNews();
    this.gobalFunctionService.setTitle('การจัดการข่าวสาร');
  }

  addNews() {
    window.open('/news-management/manage-news?isEdit=false', '_blank');
  }

  getAllNews() {
    this.newsService.getAllNews().subscribe(res => {
      this.allNews = res.result.reverse();
      console.log(this.allNews);

      this.refresh();
    });
  }

  edit(row) {
    window.open('/news-management/manage-news?isEdit=true&news_id=' + row.NEWS_ID, '_blank');
  }

  duplicate(row) {
    window.open('/news-management/manage-news?isEdit=false&news_id=' + row.NEWS_ID, '_blank');
  }

  changeStatus(event, news) {
    const dialogConfig = new MatDialogConfig();
    let body;

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';

    if (news.NEWS_STATUS) {
      dialogConfig.data = {
        title: 'คุณต้องการเปลี่ยนสถานะการมองเห็น?',
        description: 'คุณต้องการเปิดสถานะการมองเห็น ผู้ใช้จะสามารถเห็นข่าวสารได้',
        actionBtnText: 'ยืนยัน',
        cancleBtnText: 'ยกเลิก'
      }
      body = {
        NEWS_ID: news.NEWS_ID,
        NEWS_STATUS: 0
      }
    } else {
      dialogConfig.data = {
        title: 'คุณต้องการเปลี่ยนสถานะการมองเห็น?',
        description: 'คุณต้องการปิดสถานะการมองเห็น ผู้ใช้จะไม่สามารถเห็นข่าวสารได้',
        actionBtnText: 'ยืนยัน',
        cancleBtnText: 'ยกเลิก'
      }
      body = {
        NEWS_ID: news.NEWS_ID,
        NEWS_STATUS: 1
      }
    }

    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    modal.afterClosed().subscribe(res => {
      if (res) {
        this.newsService.updateStatusById(body).pipe(
          switchMap(() => {
            event.source.checked = news.NEWS_STATUS;
            return this.newsService.getAllNews();
          }),
          tap(res => {
            this.allNews = res.result.reverse();
          })
        ).subscribe();
      } else {
        event.source.checked = !news.NEWS_STATUS;
      }
    })
  }

  searching() {
    if (this.search !== '') {
      this.isSearch = true;
      this.searchNews = [];
      this.allNews.filter(news => {
        if (news.NEWS_TITAL.toLowerCase().includes(this.search.toLowerCase())) {
          this.searchNews.push(news)
        }
      });
      this.refreshSearch();
    } else {
      this.isSearch = false
      this.searchNews = null;
      this.getAllNews();
    }
  }

  refresh() {
    this.collectionSize = this.allNews.length;
    this.rows = this.allNews
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  refreshSearch() {
    this.collectionSize = this.searchNews.length;
    this.rows = this.searchNews
      .map((account, i) => ({ id: i + 1, ...account }))
      .slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }
}
